// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CheckboxRecurrence_wrapper__2UCIN","checked":"CheckboxRecurrence_checked__2deus","checkbox":"CheckboxRecurrence_checkbox__25YGm"};